
export { defineMessages, FormattedMessage, FormattedMessage as _L } from 'react-intl';

export { _l, intl } from '../app/lang';
